import * as React from 'react';
import FiltersOptionState from '../store/schema/FiltersOptionState';
import getBlockContentFromUnknownSenders from '../utils/getBlockContentFromUnknownSenders';
import getFiltersOption from '../store/store';
import strings from 'owa-strings/owa-options-strings';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { isConsumer } from 'owa-session-store';
import { observer } from 'mobx-react';
import {
    setContactsTrusted,
    setTrustedListsOnly,
    setBlockContentFromUnknownSenders,
} from 'owa-filters-option/lib/actions/internalActions';

let styles = require('./FiltersFull.scss');

export interface FiltersFullProps {
    isConsumer?: boolean;
    optionState?: FiltersOptionState;
}

@observer
export default class FiltersFull extends React.Component<FiltersFullProps, {}> {
    render() {
        const optionState = getFiltersOption();
        const mailboxJunkEmailConfiguration = getMailboxJunkEmailConfiguration();
        const trustedListsOnly = getFallbackValueIfNull(
            optionState.trustedListsOnly,
            mailboxJunkEmailConfiguration.TrustedListsOnly
        );
        const contactsTrusted = getFallbackValueIfNull(
            optionState.contactsTrusted,
            mailboxJunkEmailConfiguration.ContactsTrusted
        );
        const blockContentFromUnknownSenders = getFallbackValueIfNull(
            optionState.blockContentFromUnknownSenders,
            getBlockContentFromUnknownSenders()
        );
        return (
            <>
                {isConsumer()
                    ? this.renderConsumerCheckboxes(
                          blockContentFromUnknownSenders,
                          trustedListsOnly
                      )
                    : this.renderEnterpriseCheckboxes(trustedListsOnly, contactsTrusted)}
            </>
        );
    }

    private renderEnterpriseCheckboxes(
        trustedListsOnly: boolean,
        contactsTrusted: boolean
    ): JSX.Element {
        return (
            <>
                <Checkbox
                    label={strings.options_blockAllow_trustedListsOnlyEnterprise}
                    checked={trustedListsOnly}
                    onChange={this.onChangeTrustedListsOnly}
                    className={styles.checkbox}
                />
                <Checkbox
                    label={strings.options_blockAllow_trustEmailFromContacts}
                    checked={contactsTrusted}
                    onChange={this.onChangeContactsTrusted}
                    className={styles.checkbox}
                />
            </>
        );
    }

    private renderConsumerCheckboxes(
        blockContentFromUnknownSenders: boolean,
        trustedListsOnly: boolean
    ): JSX.Element {
        return (
            <>
                <Checkbox
                    label={strings.options_blockAllow_trustedListsOnlyConsumer}
                    checked={trustedListsOnly}
                    onChange={this.onChangeTrustedListsOnlyAndContactsTrusted}
                    className={styles.checkbox}
                />
                <Checkbox
                    label={strings.options_blockAllow_blockContentUnkownSendersConsumer}
                    checked={blockContentFromUnknownSenders}
                    onChange={this.onChangeBlockContentFromUnknownSenders}
                    className={styles.checkbox}
                />
            </>
        );
    }

    // Modify both trustedLists AND contacts in lockstep for consumers
    private onChangeTrustedListsOnlyAndContactsTrusted(
        ev: React.FormEvent<HTMLElement>,
        checked: boolean
    ): void {
        setTrustedListsOnly(checked);
        setContactsTrusted(checked);
    }

    private onChangeTrustedListsOnly(ev: React.FormEvent<HTMLElement>, checked: boolean): void {
        setTrustedListsOnly(checked);
    }
    private onChangeContactsTrusted(ev: React.FormEvent<HTMLElement>, checked: boolean): void {
        setContactsTrusted(checked);
    }
    private onChangeBlockContentFromUnknownSenders(
        ev: React.FormEvent<HTMLElement>,
        checked: boolean
    ): void {
        setBlockContentFromUnknownSenders(checked);
    }
}
